module.exports = __webpack_public_path__ + "img/4.bd74ef19.png";